import * as Yup from "yup";

export const EditUserSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("First Name is required")
    .min(2, "First Name must be at least 2 characters long"),
  lastName: Yup.string()
    .required("Last Name is required")
    .min(2, "Last Name must be at least 2 characters long"),
  email: Yup.string()
    .required("Email is required")
    .email("Invalid email format"),
  status: Yup.boolean().required("Status is required"),
  userRole: Yup.array().required("User Role is required"),
});
